import { data, Outlet } from "react-router";
import type { LocaleHandle } from "~/app/lib/locale";

export const handle: LocaleHandle = { locale: "en" };

export function loader() {
  return data(null, {
    headers: {
      "Cache-Control":
        "public, max-age=300, s-maxage=3600, stale-while-revalidate=86400",
    },
  });
}

export default function MarketingLayoutEN() {
  return <Outlet />;
}
